
import React, { useEffect } from 'react';
import { toggleSubmitActive } from '../../../../redux/testPage/testPage.actions';
import { connect } from 'react-redux';

import { appendScript } from '../../../../utils/appendScript';

const mapDispatchToProps = (dispatch) => {
	return {
		toggleSubmitActive: (val) => dispatch(toggleSubmitActive(val)),
	};
};

const mapStateToProps = (state) => {
	const { leftSectionProps } = state.rootReducer.testPageDetails;

	return {
		leftSectionProps,
	};
};

const TextArea = ({ toggleSubmitActive, isTestActive,leftSectionProps: { textLength } }) => {
	useEffect(() => {
		appendScript('wordcount');
	}, []);

	const disableEntry = (e) => {
		e.preventDefault();
	};

	const disallowChar = (e) => {
		var reg = /[^a-zA-Z0-9\s~!@$#%()-;,.?/:'&"]+$/;
		if (reg.test(e.key)) {
			e.preventDefault();
		}
	};

	return (
		<div className="quiz-area-answer">
			<p
				style={{ display: 'none' }}
				className="error test_validation"
				id="errorWrite"
			>
				Please answer this question
			</p>	
			<textarea
				className="form-control"
				name="textResponse"
				id="textResponse"
				onChange={(e) => {
					toggleSubmitActive(false);
				}}
				rows={textLength}
				placeholder="Please answer this question"
				spellCheck={isTestActive ? "false" : "true"}
				onPaste={disableEntry}
				onCut={disableEntry}
				onCopy={disableEntry}
				onKeyPress={disallowChar}
				onInput={(e) => {
					e.target.setAttribute('spellCheck', 'false');
					e.target.value = e.target.value.replace(/[^\w\s!@#$%()-;,.?/:'&"]/g, '');
				  }}
			></textarea>
			Word Count: <span id="display_count">0</span>
		</div>
	);
};
export default connect(mapStateToProps, mapDispatchToProps)(TextArea);

